import React, { useEffect, useRef, useState } from "react";
import * as gruzovikiApi from "../../utils/api.js";

function AddCard() {
  const token = localStorage.getItem("token");
  const tg = window.Telegram?.WebApp;
  tg?.expand?.();

  const [userId, setUserId] = useState(null);
  const containerRef = useRef(null);
  const widgetRef = useRef(null); // чтобы не инициализировать 2 раза
  const sentRef = useRef(false); // чтобы не слать дважды

  useEffect(() => {
    document.body.classList.add("bg-add-card");
    return () => document.body.classList.remove("bg-add-card");
  }, []);

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    });

  useEffect(() => {
    let user_id;
    if (tg?.initDataUnsafe?.user) {
      user_id = tg.initDataUnsafe.user.id;
    } else {
      const params = new URLSearchParams(window.location.search);
      const idFromUrl = Number(params.get("userId"));
      user_id = idFromUrl;
    }
    setUserId(user_id);

    gruzovikiApi
      .getUserType(user_id, token)
      .then((userType) => {
        const excludedUserIds = [837143843, 5267329136, 425169377];
        if (user_id && userType === 2 && !excludedUserIds.includes(user_id)) {
          // window.location.href = "https://cargo.gruz.app";
        }
      })
      .catch((err) => {
        console.error("Ошибка получения типа пользователя:", err);
      });
  }, []);

  // хелпер: достаём user_id из Telegram/URL/запаса
    const resolveUserId = () => {
      // 1) Telegram WebApp (безопасный способ)
      const tg = window.Telegram?.WebApp;
      if (tg?.initDataUnsafe?.user?.id) return tg.initDataUnsafe.user.id;

      return null;
    };

   // 👉 функция отправки на сервер
  const handlePayoutSuccess = async (data) => {
    if (sentRef.current) return;
    sentRef.current = true;

    const userId = resolveUserId() ?? userId; // берём «живой» id, а state — как запасной
      if (!userId) {
        console.error("User ID не найден");
        sentRef.current = false;        // позволим повторить
        return;
      }

    const payload = {
      user_id: userId,
      payout_data: data,
      // полезно для верификации на бэке
      telegram_init_data: tg?.initData || null,
    };

    try {
      // отправляем на ваш бэкенд
      await gruzovikiApi.savePayoutToken(payload, token);
      // tg?.showAlert?.("Карта успешно добавлена");
      // при необходимости — закрыть экран
        console.log(payload)
      // tg?.close?.();

      // Задержка перед закрытием tg
      setTimeout(() => {
          tg.close();
      }, 500); // Задержка в 500 миллисекунд

    } catch (e) {
      // console.error("Не удалось сохранить payout_token:", e);
      // tg?.showAlert?.("Не удалось сохранить карту. Попробуйте позже.");
      // sentRef.current = false; // позволим попытаться ещё раз
    }

    // альтернативно/дополнительно — слать в бота (если так устроен ваш флоу)
    // try {
    //   tg?.sendData?.(JSON.stringify({ type: "payout_token", ...payload }));
    // } catch {}
  };

  useEffect(() => {
  const initWidget = async () => {
    try {
      if (widgetRef.current) return;

    await loadScript("https://yookassa.ru/payouts-data/3.1.0/widget.js");

      if (!window.PayoutsData) {
        console.error("PayoutsData не найден в window");
        return;
      }

      const payoutsData = new window.PayoutsData({
          type: "safedeal",
          account_id: "1142057",
          success_callback: (data) => handlePayoutSuccess(data),
          error_callback: (error) => console.error("Payouts error:", error),
        });

        widgetRef.current = payoutsData;

        await payoutsData.render('payout-form');
        console.log("PayoutsData widget rendered");
    } catch (e) {
      console.error("Не удалось инициализировать PayoutsData:", e);
    }
  };

  if (containerRef.current) initWidget();

  return () => {
    if (containerRef.current) containerRef.current.innerHTML = "";
    widgetRef.current = null;
  };
}, []);

  return (
    <div className="add-card">
      {/* Дай контейнеру видимую высоту/ширину, чтобы не схлопнулся */}
      <div id="payout-form" ref={containerRef} style={{ minHeight: 320 }} />
    </div>
  );
}

export default AddCard;
